export enum TicketServeTypeEnum {
    ServeIreland = 1,
    ForeignServeIrishClient = 2,
    ForeignClientIrishServe = 3,
}
